import { AppContext } from 'commons-ui';
import { useContext } from 'react';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData, setConfirmationDialog, setSubmitConfirmationDialog, removeVersionLayouts, clearLocalStorageForConfig } =
		params;
	const { showAlert } = useContext(AppContext);

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/homepagelayout/edit',
					state: {
						rowData
					}
				});
			};

		case 'layouts':
			return () => {
				history.push({
					pathname: '/dashboard/homepagelayout/layout',
					state: {
						rowData
					}
				});
			};

		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/homepagelayout/create'
				});
			};

		case 'back':
			return () => {
				history.push({
					pathname: '/dashboard/homepagelayout/list'
				});
			};

		case 'remove': {
			const remove = () => {
				return removeVersionLayouts(rowData, showAlert);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove from app?',
					handleAlertConfirmation: remove
				});
			};
		}

		case 'submit': {
			return () => {
				setSubmitConfirmationDialog();
			};
		}

		case 'clear': {
			return () => {
				clearLocalStorageForConfig();
			};
		}

		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
